import { CallState } from '../../../../features/call/call.types';
import { type CallService } from '../../interface';
import { type Plugin } from '../../../pluggableService/pluggableService';
import { type AspectRatio, VideoQuality } from '../../../../webrtc/media';

export class KeyboardShortcutsPlugin implements Plugin<CallService, object> {
  name = 'KeyboardShortcutsPlugin';

  private callService?: CallService;

  private profile: VideoQuality = 'sd';

  private aspectRatio: AspectRatio = '16:9';

  apply<T extends CallService>(callService: T): T {
    this.callService = callService;
    this.callService.state.subscribe((state) => {
      if (state.matches(CallState.InProgress)) {
        window.document.addEventListener('keydown', this.keydownListener);
      } else if (state.matches(CallState.Leaving)) {
        window.document.removeEventListener('keydown', this.keydownListener);
      }
    });

    return callService;
  }

  keydownListener = (event: KeyboardEvent): void => {
    if (
      event.ctrlKey &&
      (event.key === '1' ||
        event.key === '2' ||
        event.key === '3' ||
        event.key === '4' ||
        event.key === '5')
    ) {
      event.preventDefault();

      switch (event.key) {
        case '1': {
          this.profile = 'ld';
          void this.callService?.setVideoQuality(
            this.profile,
            'KeyboardShortcutsPlugin - CTRL+1 keyboard shortcut',
            this.aspectRatio,
          );
          break;
        }
        case '2': {
          this.profile = 'sd';

          void this.callService?.setVideoQuality(
            this.profile,
            'KeyboardShortcutsPlugin - CTRL+2 keyboard shortcut',
            this.aspectRatio,
          );
          break;
        }
        case '3': {
          this.profile = 'hd';
          void this.callService?.setVideoQuality(
            this.profile,
            'KeyboardShortcutsPlugin - CTRL+3 keyboard shortcut',
            this.aspectRatio,
          );
          break;
        }
        case '4': {
          this.aspectRatio = '4:3';
          void this.callService?.setVideoQuality(
            this.profile,
            'KeyboardShortcutsPlugin - CTRL+4 keyboard shortcut',
            this.aspectRatio,
          );
          break;
        }
        case '5': {
          this.aspectRatio = '16:9';
          void this.callService?.setVideoQuality(
            this.profile,
            'KeyboardShortcutsPlugin - CTRL+5 keyboard shortcut',
            this.aspectRatio,
          );
          break;
        }
      }
    }
  };

  destroy(): void {
    window.document.removeEventListener('keydown', this.keydownListener);
  }
}
